(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_fec34c6"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('velorea-tee-guide')){
  customElements.define('velorea-tee-guide',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      const dialog=this.querySelector('dialog');
      const trigger=this.querySelector('button[aria-haspopup="dialog"]');
      if(!dialog||!trigger)return;
      trigger.addEventListener('click',()=>dialog.showModal(),{signal:this.controller.signal});
      dialog.addEventListener('click',(event)=>{
        if(event.target!==dialog)return;
        const bounds=dialog.getBoundingClientRect();
        if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
      },{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
